import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'

export interface RelationTypeChangeConfirmModalProps {
  show: boolean
  items: { key: string | number; label: string; from: string; to: string }[]
  singleChangeAllowed: boolean
  onCancel: () => void
  onApplySingle: () => void
  onApplyAll: () => void
}

export const RelationTypeChangeConfirmModal: React.FC<RelationTypeChangeConfirmModalProps> = ({
  show,
  items,
  singleChangeAllowed,
  onCancel,
  onApplySingle,
  onApplyAll
}) => (
  <Modal show={show} onHide={onCancel} className='relation-type-confirm-modal' centered>
    <Modal.Header>
      <Modal.Title>関連種別の変更</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>同じ親記事の他の記事と関連種別が異なります。</p>
      <ul>
        {items.map(({ key, label, from, to }) => (
          <li key={key}>
            {label}：{from} → {to}
          </li>
        ))}
      </ul>
      {!singleChangeAllowed && (
        <Alert variant='warning'>
          合わせ記事と他の関連種別の記事は同じ親記事に混在できないため、この記事のみの変更はできません。
        </Alert>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant='secondary' onClick={onCancel}>
        キャンセル
      </Button>
      <Button variant='outline-primary' onClick={onApplySingle} disabled={!singleChangeAllowed}>
        この記事のみ変更
      </Button>
      <Button variant='primary' onClick={onApplyAll}>
        同じ親の記事すべてに適用
      </Button>
    </Modal.Footer>
  </Modal>
)
